module.exports = __webpack_public_path__ + "static/Zed-28187a6e0afc1b8ffe277cd8d8296ff8.png";